import {
    SET_SPELLING_CONTENT, SET_ENABLED_RESPONSES,
    SET_READY_SCRIPT_PLAYED, SET_BUTTON_GRID_ENABLED,
    SET_CLEAR_BUTTON_ENABLED,
} from './spellingActions';
import { PRACTICE, QUESTIONS } from '../constants/assessmentItemType';
import { SET_PLAYLIST_ITEM_COMPLETED } from '../common/playlist/playlistActions';
import { SPELLING } from '../constants/measure';

const contentDefaultState = {
    isDataFetched: false,
    formId: undefined,
    [PRACTICE]: {},
    [QUESTIONS]: {},
};

export const defaultState = {
    ...contentDefaultState,
    isReadyScriptPlayed: false,
    isButtonGridEnabled: true,
    enabledResponses: undefined,
};

const mapPracticeContent = (question) => ({
    correctResponse: question.correct_response,
    stimulus: {
        audio: question.stimulus.audio,
    },
});

const mapQuestionsContent = (question) => ({
    itemId: question.item_id,
    stimulus: {
        audio: question.stimulus.audio,
    },
});

const reformatSpellingContent = (apiContent) => ({
    assessment: apiContent.assessment,
    measure: apiContent.measure,
    formId: apiContent.form_id,
    grade: apiContent.grade,
    period: apiContent.period,
    practice: apiContent.practice.map(mapPracticeContent),
    questions: apiContent.questions.map(mapQuestionsContent),
});

const spellingReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SET_SPELLING_CONTENT:
        return {
            ...state,
            isDataFetched: true,
            ...reformatSpellingContent(action.content[0]),
        };
    case SET_ENABLED_RESPONSES:
        return {
            ...state,
            enabledResponses: action.responses,
        };
    case SET_READY_SCRIPT_PLAYED:
        return {
            ...state,
            isReadyScriptPlayed: true,
        };
    case SET_BUTTON_GRID_ENABLED:
        return {
            ...state,
            isButtonGridEnabled: action.isEnabled,
        };
    case SET_CLEAR_BUTTON_ENABLED:
        return {
            ...state,
            isClearButtonEnabled: action.isEnabled,
        };
    case SET_PLAYLIST_ITEM_COMPLETED: {
        if (action.measureKey === SPELLING.ASSESSMENT) {
            return defaultState;
        }
        return state;
    }
    default:
        return state;
    }
};

export default spellingReducer;
